module.exports = __webpack_public_path__ + "static/Gabriel-d3a53d4dd6a38470912493d9a7732464.png";